import { AvForm } from 'availity-reactstrap-validation'
import RenderFields from '../../../CMSComponent/Forms/renderFields'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearCurrentRowData, clearParentTableData, fetchUpdateApiData } from '../../../Redux/Reducers/CMS'
import { primary_color } from '../../../Helper/uiHelper'
import { request } from '../../../Redux/Sagas/requests/api'
import { isSuccessResponse } from '../../../helper'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

const EditBookingDetails = ({ setAddGridDataDetail, addDataDetail, addFormList, fetechLogsCount }) => {
  const currentRow = useSelector((state) => state.CMS.currentRow)

  const [formFieldValue, setFormFieldValue] = useState({})
  const [defaultSingleFormValue, setDefaultSingleFormValue] = useState()
  const [loading, setLoading] = useState(false)
  const [alreadyBookedWarning, setAlreadyBookedWarning] = useState(null)
  const [pendingValues, setPendingValues] = useState(null)
  const dispatch = useDispatch()

  useEffect(() => {
    if (currentRow?.[1]) {
      setDefaultSingleFormValue(currentRow?.[1])
    }
  }, [currentRow?.length])

  const onCloseForm = () => {
    dispatch(fetchUpdateApiData())
    if (!addDataDetail?.isAddNew) {
      dispatch(clearCurrentRowData())
      dispatch(clearParentTableData())
    }
    setAddGridDataDetail({ open: false })
  }

  const onSave = (values, confirmAlreadyBooked = false) => {
    setLoading(true)
    request('update-unit-details', 'POST', {
      ...values,
      unit_id: currentRow?.[1]?.id,
      confirm_already_booked: confirmAlreadyBooked,
    }).then((res) => {
      if (res?.status === 409 && res?.data?.already_booked) {
        setPendingValues(values)
        setAlreadyBookedWarning(res?.data?.message || `This locker is already booked under booking ID ${res?.data?.booking_id}.`)
        setLoading(false)
        return
      }
      if (isSuccessResponse(res, 'Details updated successfully!')) {
        setAlreadyBookedWarning(null)
        setPendingValues(null)
        onCloseForm()
      }
      fetechLogsCount()
      setLoading(false)
    })
  }

  if (addFormList?.length !== 1) return
  return (
    <div className='p-4 px-5'>
      <AvForm
        onValidSubmit={(e, values) => {
          onSave(values)
        }}>
        <RenderFields
          allForm={addFormList}
          content={addFormList}
          twoCol={true}
          defaultFormValue={defaultSingleFormValue}
          formFieldValue={formFieldValue}
          setFormFieldValue={setFormFieldValue}
          noCache={true}
        />
        <div className='d-flex justify-content-end mt-5'>
          {' '}
          <button
            className='btn rounded-pill mt-2 text-danger border-danger mr-3'
            type='button'
            id='close-btn'
            onClick={(e) => {
              onCloseForm()
              e.preventDefault()
              e.stopPropagation()
            }}
            style={{ fontWeight: 700, width: '12rem' }}>
            Close
          </button>
          <button
            className='btn text-white rounded-pill mt-2 mr-3'
            disabled={!!loading}
            type='submit'
            id='save-button'
            style={{ background: primary_color, fontWeight: 700, width: '14rem' }}>
            {loading ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </AvForm>
      <Modal isOpen={!!alreadyBookedWarning} centered toggle={() => setAlreadyBookedWarning(null)}>
        <ModalHeader toggle={() => setAlreadyBookedWarning(null)}>Locker already booked</ModalHeader>
        <ModalBody>{alreadyBookedWarning}</ModalBody>
        <ModalFooter>
          <Button
            color='secondary'
            onClick={() => {
              setAlreadyBookedWarning(null)
              setPendingValues(null)
            }}>
            Cancel
          </Button>
          <Button
            color='primary'
            disabled={!!loading}
            onClick={() => {
              if (pendingValues) {
                onSave(pendingValues, true)
              }
            }}>
            Continue anyway
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default EditBookingDetails
